<script setup lang="ts">
defineProps({
  iconColor: {
    type: String,
    default: "bg-blue",
  },
});

</script>

<template>
  <v-card variant="outlined" class="bg-white">
    <v-row class="pa-4">
      <v-col>
        <h3>
          <slot name="title" />
        </h3>
        <slot name="description" />
      </v-col>
    </v-row>
    <v-divider />
    <v-row class="pa-4">
      <slot />
    </v-row>
  </v-card>
</template>

<style scoped>

</style>
